module.exports = __webpack_public_path__ + "img/vertical_4_7_5012.8c181965.png";